import { Injectable } from '@angular/core';
import { StateService, UrlService } from '@uirouter/angular';

import { LoginRedirectService, SSOLoginPath } from 'rev-shared/security/LoginRedirect.Service';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

interface IErrorDetail {
	data?: any; // angularjs
	error?: any; // angular
	status: number;
}

@Injectable({
	providedIn: 'root'
})
export class SecurityRedirectHelperService {
	constructor(
		private $state: StateService,
		private LoginRedirectService: LoginRedirectService,
		private UserContext: UserContextService,
		private urlService: UrlService
	) {}

	public onError(errorDetail: IErrorDetail, fromStateName: string): void {
		if (!errorDetail) {
			return;
		}

		const errorData: any = errorDetail.data || // angularjs
			errorDetail.error; // angular
		const errorStatus: number = errorDetail.status;
		const errorReason: any = errorData?.reason;
		const noLoginRedirect: boolean = errorData?.noLoginRedirect;
		console.log('SecurityRedirectHelperService.onError', errorDetail);

		switch (errorStatus) {
			case 401: // unauthorized
				console.error('401 error, not authenticated');
				if(!noLoginRedirect) {
					if (this.UserContext.isRegisteredGuest()) {
						this.UserContext.logOutUser();
						this.redirectToLogin();
						return;
					}
					const user = this.UserContext.getUser();
					if (!user.id && !user.token) {
						this.redirectToLogin();
						return;
					}
				}
				this.$state.go(
					fromStateName.startsWith('portal') ? 'portal.401' : '401',
					{ reason: errorReason },
					{ location: false });
				return;

			case 404: // not found
				this.$state.go('portal.404');
				return;
		}
	}

	private redirectToLogin(): void {
		const fwdUrl: string = this.urlService.url();

		if (!fwdUrl.startsWith('/login') && !fwdUrl.startsWith(SSOLoginPath)) {
			window.setTimeout(() => this.LoginRedirectService.redirectToLogin(fwdUrl), 100);
		}
	}
}
